import { render, staticRenderFns } from "./TranslationsDatatable.vue?vue&type=template&id=0a827df1"
import script from "./TranslationsDatatable.vue?vue&type=script&lang=js"
export * from "./TranslationsDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports